<template>
  <v-container full-width style="width: 100%">
    <v-row no-gutters="">
      <v-col sm="12">
        <v-text-field
          :append-icon="'fas fa-search fa-sm'"
          clearable
          light
          regular
          ref="searchBox"
          :label="placeholder"
          v-model="searchQuery"
          type="search"
          @click:append="search"
          @keyup.enter.native="search"
          :rules="validationRules"
          :hide-details="!validationRules || validationRules.length == 0"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    config: {
      // some pages have search filled but they are not children of baseList
      required: false,
      default: () => ({ initValue: null, initSearch: true, rules: [] })
    }
  },
  data() {
    return {
      validationRules: [],
      searchQuery: null
    };
  },
  watch: {
    config: {
      /**
       * @param val
       * @param oldVal
       */
      handler: function (val) {
        this.searchQuery = val ? val?.initValue : null;
        this.validationRules = val ? val?.rules : [];
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.config?.initValue && this.config?.initSearch != false) {
      this.search();
    }
  },
  computed: {
    placeholder() {
      const TRANSLATE_ID = this.config?.placeholder || "searchDefault";
      return this.$t(TRANSLATE_ID);
    }
  },
  methods: {
    search() {
      if (this.config?.rules && this.config?.rules.length != 0) {
        if (this.$refs.searchBox?.valid) this.$emit("search", this.searchQuery);
      } else {
        this.$emit("search", this.searchQuery);
      }
    },
    searchChanged() {
      this.$emit("queryupdated", this.searchQuery);
    }
  }
};
</script>

<style scoped>
.container {
  padding: 0 !important;
}

.v-input__slot {
  height: 40px;
  min-height: unset;
}
</style>
